import { later, next } from '@ember/runloop';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { Direction, PopupEvent } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class GuidedOnboardingDataManagerSelectedTour extends TourBase {
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	get id(): string {
		return TourId.GUIDED_ONBOARDING__DATA_MANAGER_SELECTED;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: 1,
				direction: Direction.LEFT,
				attachTo: () => {
					return $(
						'.popup-type-data-source-selected-connections .sources-map .actions a:not(.link)',
					).eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();

		const popup = this.mmSourceTypesService.openSelectedConnectionsPopup(false);

		popup.on(PopupEvent.OPENED, this, () => {
			later(() => {
				this.goToStep(1); // Hack to reposition blue bubble
			}, 400);
		});

		popup.on(PopupEvent.CLOSED, this, () => {
			next(() => {
				this.flowTourOnboardingService.continueTour();
			});
		});
	}
}
